<!-- Support Cases Section -->
<div class="mb-4">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="mb-0">Support Cases</h5>
    <button class="btn btn-sm btn-primary" (click)="openCreateCase()">Create Case</button>
  </div>

  <div *ngIf="casesLoading" class="text-center py-3">
    <div class="spinner-border spinner-border-sm" role="status"></div>
  </div>

  <ag-grid-angular
    *ngIf="cases.length > 0"
    class="ag-theme-alpine"
    [rowData]="cases"
    [columnDefs]="casesColumnDefs"
    [defaultColDef]="defaultColDef"
    [domLayout]="'autoHeight'"
    (gridReady)="onCasesGridReady($event)"
    [rowHeight]="42">
  </ag-grid-angular>

  <div *ngIf="!casesLoading && cases.length === 0" class="text-center text-muted py-3">
    No support cases defined.
  </div>
</div>

<!-- Case Form Modal -->
<div *ngIf="showCaseForm" class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,0.5)" (click)="$event.target === $event.currentTarget ? closeCaseForm() : null">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ editingCase ? 'Edit Case' : 'Create Case' }}</h5>
        <button type="button" class="btn-close" (click)="closeCaseForm()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Name</label>
          <input type="text" class="form-control" [(ngModel)]="caseFormModel.name" placeholder="Case name">
        </div>
        <div class="mb-3">
          <label class="form-label">Instructions</label>
          <textarea class="form-control" [(ngModel)]="caseFormModel.instructions" rows="8" placeholder="Agent instructions for this case type"
            #instructionsTextarea
            style="overflow-y: hidden; max-height: 60vh"
            (input)="autoResizeInstructions(instructionsTextarea)"></textarea>
        </div>
        <div class="mb-3 form-check">
          <input type="checkbox" class="form-check-input" id="caseAutoclose" [(ngModel)]="caseFormModel.autoclose">
          <label class="form-check-label" for="caseAutoclose">Enable autoclose</label>
        </div>
        <div class="mb-3">
          <label class="form-label">Sort Order</label>
          <input type="number" class="form-control" [(ngModel)]="caseFormModel.sortOrder">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeCaseForm()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveCase()" [disabled]="!caseFormModel.name || !caseFormModel.instructions">
          {{ editingCase ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Case History Modal -->
<div *ngIf="showHistoryModal" class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,0.5)" (click)="$event.target === $event.currentTarget ? closeHistoryModal() : null">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Change History: {{ historyCase?.name }}</h5>
        <button type="button" class="btn-close" (click)="closeHistoryModal()"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="historyLoading" class="text-center py-3">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>

        <div *ngIf="!historyLoading && historyEntries.length === 0" class="text-muted text-center">
          No change history for this case.
        </div>

        <table *ngIf="historyEntries.length > 0" class="table table-sm">
          <thead>
            <tr>
              <th>Date</th>
              <th>Field</th>
              <th>Old Value</th>
              <th>New Value</th>
              <th>Changed By</th>
              <th>Summary</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of historyEntries">
              <td>{{ entry.createdAt | date:'short' }}</td>
              <td>{{ entry.fieldName }}</td>
              <td><small>{{ entry.oldValue || '—' }}</small></td>
              <td><small>{{ entry.newValue || '—' }}</small></td>
              <td>{{ entry.changedBy }}</td>
              <td><small>{{ entry.changeSummary || '—' }}</small></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeHistoryModal()">Close</button>
      </div>
    </div>
  </div>
</div>
